import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ValidatorFn, FormControl } from '@angular/forms';
import { HttpParams, HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { BusinessDayService } from '../../services/business-day.service';
import { SWAlertService } from '../../services/swalert.service';
import { Router, Data, ActivatedRoute } from '@angular/router';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead/public_api';
import { filter, map } from 'rxjs/operators';
import { DatePipe, DecimalPipe } from '@angular/common';
import { noop } from 'rxjs';
import Swal from 'sweetalert2';
import { invalid } from '@angular/compiler/src/render3/view/util';
import { element } from 'protractor';
import { TSFuntionService } from '../../services/ts-funtion.service';
import { isUndefined } from 'util';
import { any } from '@amcharts/amcharts4/.internal/core/utils/Array';
import { UploadfileService } from '../../services/uploadfile.service';
import { number } from '@amcharts/amcharts4/core';
declare var Uploadfiles, Extension, _Path, SetData, Clearuploadfile: any, Accept: any;
declare var ArrFile: any[];

@Component({
  selector: 'app-advancerequest',
  templateUrl: './advancerequest.component.html',
  styleUrls: ['./advancerequest.component.css'],
  providers: [DatePipe]
})
export class AdvancerequestComponent implements OnInit {
  AdvanceRequestForm: FormGroup;//สร้างกลุ่ม Object Data
  get f() { return this.AdvanceRequestForm.controls; }//ประกาศเพื่อใช้เรียกไปยัง From หน้าบ้าน
  constructor(private formBuilder: FormBuilder,
    private http: HttpClient,
    private BusinessDay: BusinessDayService,
    private SW: SWAlertService,
    private router: Router,
    private datepipe: DatePipe,
    private Swal: SWAlertService,
    private activatedRoute: ActivatedRoute,
    private _decimalPipe: DecimalPipe,
    private System: TSFuntionService,
    private uploadService: UploadfileService) {
  }
  isReject: boolean = false;
  _RequestType = []; //ตัวแปรเก็บ nReqType
  _Holidays = []; //ตัวแปรเก็บ dDate วันหยุด
  sDate = new Date(); //ตัวแปรเก็บวันที่ปัจจุบัน
  Todate: Date; //ตัวแปรเก็บวันที่
  Holidays = []; //ตัวแปรรับค่า holiday
  ArrEmployee: any[] = []; //ตัวแปร array เก็บค่า ContactName
  DataEmployee: any = []; //ตัวแปร array เก็บค่า ContactName
  DataBusinessArea: any = [];
  ArrsRequestCode: any[] = []; //ตัวแปร array เก็บค่า CopyRequestNo
  DatasRequestCode: any = []; //ตัวแปร array เก็บค่า CopyRequestNo
  ArrVENDOR_CODE: any[] = []; //ตัวแปร array เก็บค่า VendorCode
  DataVENDOR_CODE: any = []; //ตัวแปร array เก็บค่า VendorCode
  ArrApprover1: any[] = []; //ตัวแปร array เก็บค่า Approver
  DataApprover1: any = []; //ตัวแปร array เก็บค่า Approver
  ArrApprover2: any[] = []; //ตัวแปร array เก็บค่า Approver
  DataApprover2: any = []; //ตัวแปร array เก็บค่า Approver
  ArrTM_Flows: any[] = []; //ตัวแปร array เก็บค่า TM_Folws
  DataTM_Flows: any = []; //ตัวแปร array เก็บค่า TM_Folws
  ArrDataAll: any[] = []; //ตัวแปร array เก็บค่าข้อมูลทั้งหมดที่นำมา Edit
  DataAll: any = []; //ตัวแปร array เก็บค่าข้อมูลทั้งหมดที่นำมา Edit
  DataCopyReqID: any = []; //ตัวแปร array เก็บค่าข้อมูลทั้งหมดที่นำมา Edit
  DataDisplayApprover: any = []; //ตัวแปร array เก็บค่าข้อมูลทั้งหมดที่นำมา Edit
  message = ''; //message แสดงเมื่อวันที่ due date อยู่ในช่วงระวัง 1-7 วันถัดไป
  olddate = ''; //message แสดงเมื่อวันที่ due date อยู่ในช่วงระวัง 1-7 วันถัดไป
  _Currency = []; //ตัวแปร array เก็บค่า Currency
  sRequestID: any = ""; //ตัวแปร string เก็บค่า sRequestID
  sRequestCode: any = ""; //ตัวแปร string เก็บค่า sRequestCode
  sComment: any = "";
  sCommentSSC: any = "";
  IsShowREQ: boolean = false;
  IsNoDataTrans: boolean = true;
  IsShowComment: boolean = false;
  contextmenu: boolean = false;
  noResult = false;
  IsReqUrgent: boolean = true;
  fieldsetDisabled: boolean = false;
  cbApprover1: boolean = false;
  IsEdit: boolean = false;
  _NameApprover1: any;
  nStatusID: any = 1;
  IsApprover_1: any = true;
  IsApprover_2: any = true;
  nApproveID1;
  nApproveID2;
  cActive = "";
  Mindate: Date;
  ResultPermission: boolean = false;
  clicked: boolean  = false;
  nReqUrgentDay: any = 0;
  dStartDate: any = new Date;
  IsOlddate: boolean = false;
  fileType: any;
  limitFile: any;
  ArrTransactionHistory: any;
  isNewRequest: boolean = false;
  isForROS: boolean = false;
  urgentDay: number = 6;
  async ngOnInit() {
    this.System.BlockUI();

    let ua = this.System.GetUserStorage();
    this.AdvanceRequestForm = this.formBuilder.group({ //ประกาศ FormControl จากหน้า html
      sRequestID: ["0"], //ตัวแปรเก็บ sRequestID set ค่าให้เริ่มที่ 0
      sRequestCode: ["0"], //ตัวแปรเก็บ sRequestCode set ค่าให้เริ่มที่ 0
      nCompanyCode: [ua.sCompCode], //ตัวแปรเก็บ nCompanyCode set ค่าให้เริ่มที่ 388
      sCompanyName: [ua.sCompName], //ตัวแปรเก็บ sCompanyName set ค่าให้เริ่มที่ บริษัท สานพลัง วิสาหกิจเพื่อสังคม จำกัด
      sContactID: [ua.nUserID], //ตัวแปรเก็บ sContactID set ค่าให้เป็นค่าว่าง
      sContactName: [ua.sFullName, [Validators.required]], //ตัวแปรเก็บ sContactName set ค่าให้เป็นค่า null และใส่ validate
      sUnit: [ua.sUnitName], //ตัวแปรเก็บ sUnit set ค่าให้เป็นค่า null
      sDate: [new Date], //ตัวแปรเก็บวันที่ปัจจุบัน
      sEmail: [ua.sEmail, Validators.pattern("^[^@\\s]+@([^@\\s]+\\.)+[^@\\s]+$")], //ตัวแปรเก็บ sEmail set ค่าให้เป็นค่า null และใส่ validate email
      sTel: [ua.sTel], //ตัวแปรเก็บ sTel set ค่าให้เป็นค่า null
      sBusinessArea: [null],
      nReqType: ["20"], //ตัวแปรเก็บ nReqType set ค่าให้เป็นค่า 20
      sCopyReqID: [null],
      sCopyofReqNo: [null], //ตัวแปรเก็บ sCopyofReqNo set ค่าให้เป็นค่า null
      dDue: [new Date, [Validators.required]], //ตัวแปรเก็บ dDue set ค่าให้เป็นค่า null และใส่ validate
      IsReqUrgent: [this.IsReqUrgent],
      VENDOR_CODE: [null, [Validators.required]], //ตัวแปรเก็บ VENDOR_CODE set ค่าให้เป็นค่า null และใส่ validate
      sVendorName: [null], //ตัวแปรเก็บ sVendorName set ค่าให้เป็นค่า null และใส่ validate
      sTAXID: [null, [Validators.required]], //ตัวแปรเก็บ sTAXID set ค่าให้เป็นค่า null และใส่ validate
      nAmount: [null, [Validators.required]], //ตัวแปรเก็บ nAmount set ค่าให้เป็นค่า null และใส่ validate
      sCurrency: ['THB'], //ตัวแปรเก็บ sCurrency set ค่าให้เป็นค่า THB
      sVendorAddress: [null], //ตัวแปรเก็บ sVendorAddress set ค่าให้เป็นค่า null และใส่ validate
      sDescription: [null, [Validators.required]], //ตัวแปรเก็บ sDescription set ค่าให้เป็นค่า null และใส่ validate
      cbApprover1: [false], //ตัวแปรเก็บ cbApprover1 จาก checkbox ของ approver set ค่าให้เป็นค่า null
      sApproverID1: [""], //ตัวแปรเก็บ sApproverID1 ของ approver set ค่าให้เป็นค่าว่าง
      sApprover1: [null, [Validators.required]], //ตัวแปรเก็บ sApprover1 set ค่าให้เป็นค่า null และใส่ validate
      sApproverID2: [""], //ตัวแปรเก็บ sApproverID2 set ค่าให้เป็นค่าว่าง
      sApprover2: [null, [Validators.required]], //ตัวแปรเก็บ sApprover2 set ค่าให้เป็นค่า null และใส่ validate
      sComment: [null], //ตัวแปรเก็บ sApprover2 set ค่าให้เป็นค่า null และใส่ validate
      sCommentSSC: [null], //ตัวแปรเก็บ sApprover2 set ค่าให้เป็นค่า null และใส่ validate
    });

    await this.getFileType();
    await this.getFileLimit();
    //set form group
    this.AdvanceRequestForm.controls['sVendorAddress'].disable();

    this.activatedRoute.queryParams.subscribe(params => { //รับค่า sRequestID จากหน้า Home ผ่าน Parameter ชื่อ str
      this.sRequestID = (params['str']);
      if (this.sRequestID === undefined) {
        this.sRequestID = (params['ros']);
        if (this.sRequestID) {
          this.isForROS = true;
          this.urgentDay = 8;
        }
      }
      
      if(this.sRequestID === undefined){
        this.isNewRequest = true;
      }

    });
    this.sRequestID = await this.System.Decrypt(this.sRequestID);
    if (ua.IsROService && this.isForROS) {
      this.isReject = true;
    }
    ArrFile.length = 0;
    var setUp = {
      sID: "dvUploadFile", //div สร้างไฟล์
      nFileSize: 15, //max size MB
      Accepts: Accept.GetFix(this.fileType),
      Extensions: Extension.GetFix(this.fileType),
      ModeMulti: true, //multi file
      ArrFile: ArrFile, //array file upload , setup
      View: false,
      HasURL: true,
      UrlUpload: this.System.SiteName + _Path.PathUpload,
      limit: this.limitFile,
    };
    Uploadfiles(setUp);
    Clearuploadfile();
    await this.SetDataOnPageLoad();

    ////case new request
    //if (this.sRequestID == "") {
    //  this.Todate = this.BusinessDay.SetToday(this.Holidays);
    //  this.AdvanceRequestForm.patchValue({ dDue: this.Todate });
    //}
    await this.setdata(); //เรียกใช้ method setdata ที่มี method SetDataOnPageLoad,checkToday,Edit เพื่อให้ทำงานตามลำดับก่อนและหลัง

    this.System.UnBlockUI();
  }
  checkFile() {
    if (ArrFile.filter(f => f.IsDelete === false).length > 0) {
      const chkFile =  document.getElementById('dv_dvUploadFile');
      if (chkFile != null) {
        chkFile.style.border = '1px solid #dde4f6';
      }
    }
    return '';
  }
  async getFileType() {
    await this.http.get(this.System.SiteName + 'api/FileConfig/FileType').toPromise().then((data: Response) => {
      const result = [];
      const item = Object.values(data);
      for (let x = 0; x < item.length; x++ ) {
        if (data[x]['sValue'] === 'Y') {
          result.push(data[x]['sValueText']);
        }
      }
      this.fileType = result;
    });
  }
  async getFileLimit() {
    await this.http.get(this.System.SiteName + 'api/FileConfig/FileLimit').toPromise().then((data: Response) => {
      const result = [];
      const item = Object.values(data);
      for (let x = 0; x < item.length; x++ ) {
        result.push(data[x]['sValue']);
      }
      this.limitFile = result;
    });
  }
  CommentChange(event) {
    this.sComment = event.target.value == null ? "" : event.target.value;
  }
  CommentChangeSSC(event) {
    this.sCommentSSC = event.target.value == null ? "" : event.target.value;
  }
  async setdata() { //method setdata เรียกใช้ method SetDataOnPageLoad,checkToday,Edit(ส่ง sRequestID)
    let ObjData = {
      sRequestID: this.sRequestID,
      nMenuID: 7
    }
    this.ResultPermission = await this.System.CheckPermission(ObjData);
    if (this.sRequestID && !this.isNewRequest) {
      await this.Edit(this.sRequestID);
    } else {
      //Set Due Date
      this.Todate = this.BusinessDay.SetToday(this.Holidays);
      this.Mindate = this.BusinessDay.SetToday(this.Holidays);
      this.Mindate.setDate(this.Mindate.getDate() + 1);
      this.Mindate = this.BusinessDay.SetNextDate(this.Mindate, this.Holidays);
      this.AdvanceRequestForm.patchValue({
        dDue: this.Mindate
      });


      if (!this.isNewRequest) {
        let data: any;
        await this.http.get(this.System.SiteName + "api/ROService/GetRequest/" + this.sRequestID + "").toPromise().then(Data => data = Data)
        if(data != null){
          this.AdvanceRequestForm.patchValue({
            sRequestID: data[0].sRequestID,
            sComment: data[0].sComment,
            sCommentSSC: `Expected Complete Date : ${data[0].dExpectedCompleteDate}${data[0].sRemarkSSC ? `\n${data[0].sRemarkSSC}` : ''}`,
          });
          this.sComment = data[0].sComment;
          this.sCommentSSC = data[0].sRemarkSSC;
          this.onOptionsSelected_ContactName2(data[0].sFullName);
  
        }
        this.http.get<any>(this.System.SiteName + "api/PaytoEmployee/GetFle/" + this.sRequestID).subscribe(res => {
          let data = res;
          if (data) {
            let arrdata: any[] = [];
            data.forEach(f => arrdata.push({
              nID: f.nFileOrder,
              sPath: f.sPathFile,
              sSystemFileName: f.sSystemFileName,
              sFileName: f.sFileName,
              sSize: parseInt(f.sFileSize)
            }))
            SetData("dvUploadFile", arrdata)
          }
    
        });
      }
     

      this.handler(); //เรียกใช้งานแจ้งเตือน due date
    }


    //setdata sRequestCode เมื่อมีเลข sRequestCode
    if (this.sRequestCode) {
      this.IsShowREQ = true;
      this.AdvanceRequestForm.controls.sRequestCode.setValue(this.sRequestCode); //Set ค่า
    }

    this.System.UnBlockUI();
  }

  async SetDataOnPageLoad() { //method SetDataOnPageLoad ใช้ดึงข้อมูลจาก database มาจาก controller
    //RequestType
    const httpOptionsRequestType = { //ประกาศตัวแปรเพื่อส่งค่าไปยัง HttpGet
      headers: new HttpHeaders({ //ใช้ส่งค่าในการกำหนดรูปแบบการส่งข้อมูลไปยัง HttpGet
        'Content-Type': 'application/json' //ประเภทรูปแบบ Json
      })
    };
    await this.http.get<any>(this.System.SiteName + "api/AdvanceRequest/_GetRequestType", httpOptionsRequestType).toPromise().then(res => { //get nReqType
      if (res) {
        this._RequestType = res; //เก็บค่าจากตาราง TM_RequestType
      }
    });
    //ContactName
    const httpOptionsTUserpermission = { //ประกาศตัวแปรเพื่อส่งค่าไปยัง HttpGet
      headers: new HttpHeaders({ //ใช้ส่งค่าในการกำหนดรูปแบบการส่งข้อมูลไปยัง HttpGet
        'Content-Type': 'application/json' //ประเภทรูปแบบ Json
      }),
      params: new HttpParams() //ตัวแปรที่ใช้ในการระบุฟิลเพื่อส่งไปยัง Controller
        .set('nRole', "5")
        .set('sCompCode', this.AdvanceRequestForm.value.nCompanyCode)
    };
    await this.http.get<any>(this.System.SiteName + "api/AdvanceRequest/TUserpermission", httpOptionsTUserpermission).toPromise().then(res => {
      if (res) {
        this.DataEmployee = res; //ตัวแปร array object เก็บค่าจากตาราง TUserpermission
        this.ArrEmployee = this.DataEmployee.map(m => ({ //ตัวแปร array object เก็บค่าที่ map เฉพาะ column จากตาราง TUserpermission
          nUserID: m.nUserID,
          sContactName: m.sName + " " + m.sSurName,
          sEmail: m.sEmail,
          sTel: m.sTel,
          sUnit: m.sUnit
        }));
      }
    });
    //BusinessArea
    const httpOptionsBusinessArea = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }), params: new HttpParams()
        .set('sCompCode', this.AdvanceRequestForm.value.nCompanyCode)
    };
    await this.http.get<any>(this.System.SiteName + "api/AdvanceRequest/_GetBusinessArea", httpOptionsBusinessArea).toPromise().then(res => {
      if (res) {
        this.DataBusinessArea = res;
        this.AdvanceRequestForm.patchValue({
          sBusinessArea: this.DataBusinessArea[0].BUSINESS_AREA
        });
      }
    });
    //CopyRequestNo
    const httpOptionsCopyRequestNo = { //ประกาศตัวแปรเพื่อส่งค่าไปยัง HttpGet
      headers: new HttpHeaders({ //ใช้ส่งค่าในการกำหนดรูปแบบการส่งข้อมูลไปยัง HttpGet
        'Content-Type': 'application/json' //ประเภทรูปแบบ Json
      }),
      params: new HttpParams() //ตัวแปรที่ใช้ในการระบุฟิลเพื่อส่งไปยัง Controller
        .set('nReqType', "20")
        .set('sCompCode', this.AdvanceRequestForm.value.nCompanyCode)
        .set("nStatusID", "2")
    };
    await this.http.get<any>(this.System.SiteName + "api/AdvanceRequest/CopyRequestNo", httpOptionsCopyRequestNo).toPromise().then((data: Response) => {
      if (data) {
        this.DatasRequestCode = data;
        if (this.DatasRequestCode != null) {
          if (this.DatasRequestCode.length != 0) {
            this.ArrsRequestCode = this.DatasRequestCode.map(m => ({
              sCopyReqID: m.sRequestID,
              sCopyofReqNo: m.sRequestCode,
              VENDOR_CODE: m.sVendorCode,
              sVendorName: m.sVendorName,
              sTAXID: m.sTAXID,
              sVendorAddress: m.sVendorAddress,
              nAmount: this._ConvertToDecimal(m.nExcludeVAT + ""), //short if แปลงตัวเลขให้เป็น format comma
              sDescription: m.sInvoiceDesc,
              cSkipApprove1: m.cSkipApprove1,
              nApprove1: m.nApprove1,
              nApprove2: m.nApprove2
            }));
          }
        }
      }
    });
    //Holidays
    const httpOptionsHolidays = { //ประกาศตัวแปรเพื่อส่งค่าไปยัง HttpGet
      headers: new HttpHeaders({ //ใช้ส่งค่าในการกำหนดรูปแบบการส่งข้อมูลไปยัง HttpGet
        'Content-Type': 'application/json' //ประเภทรูปแบบ Json
      })
    };
    let GetHoliday = await this.http.get<any>(this.System.SiteName + "api/AdvanceRequest/Holidays", httpOptionsHolidays).toPromise();
    if (GetHoliday) {
      this.Holidays = GetHoliday.map(({ dDate }) => new Date(dDate)) //map เอาเฉพาะ column dDate type : Date
    }

    //VendorCode
    const httpOptionsVendorCode = { //ประกาศตัวแปรเพื่อส่งค่าไปยัง HttpGet
      headers: new HttpHeaders({ //ใช้ส่งค่าในการกำหนดรูปแบบการส่งข้อมูลไปยัง HttpGet
        'Content-Type': 'application/json' //ประเภทรูปแบบ Json
      })
    };
    await this.http.get<any>(this.System.SiteName + "api/Autocomplete/VD/20/" + encodeURIComponent(String(this.AdvanceRequestForm.value.nCompanyCode)), httpOptionsVendorCode).toPromise().then((data: Response) => {
      if (data) {
        this.DataVENDOR_CODE = data;
        this.ArrVENDOR_CODE = this.DataVENDOR_CODE.map(m => ({
          Vendor: m.VENDOR_CODE + " - " + m.sVendorName,
          VENDOR_CODE: m.VENDOR_CODE,
          sAddress: m.sAddress,
          sVendorName: m.sVendorName,
          TAX_NUMBER1: m.TAX_NUMBER1,
          TAX_NUMBER2: m.TAX_NUMBER2,
          TAX_NUMBER3: m.TAX_NUMBER3
        }))
      }
    })
    //Currency
    const httpOptionsCurrency = { //ประกาศตัวแปรเพื่อส่งค่าไปยัง HttpGet
      headers: new HttpHeaders({ //ใช้ส่งค่าในการกำหนดรูปแบบการส่งข้อมูลไปยัง HttpGet
        'Content-Type': 'application/json' //ประเภทรูปแบบ Json
      })
    };
    await this.http.get<any>(this.System.SiteName + "api/AdvanceRequest/Currency", httpOptionsCurrency).toPromise().then(res => {
      if (res) {
        this._Currency = res;
      }
    });
    //Approver1Name
    const httpOptionsApprover1 = { //ประกาศตัวแปรเพื่อส่งค่าไปยัง HttpGet
      headers: new HttpHeaders({ //ใช้ส่งค่าในการกำหนดรูปแบบการส่งข้อมูลไปยัง HttpGet
        'Content-Type': 'application/json' //ประเภทรูปแบบ Json
      }),
      params: new HttpParams() //ตัวแปรที่ใช้ในการระบุฟิลเพื่อส่งไปยัง Controller
        .set('sCompCode', this.AdvanceRequestForm.value.nCompanyCode)
        .set('nRole', "3")
    };
    await this.http.get<any>(this.System.SiteName + "api/AdvanceRequest/GetApprover1", httpOptionsApprover1).toPromise().then(res => {
      if (res) {
        this.DataApprover1 = res;
        this.ArrApprover1 = this.DataApprover1.map(m => ({
          nUserID: m.nUserID,
          sApprover: m.sName + " " + m.sSurName
        }));
        this.Flows(); //เรียกใช้ method Flows เพื่อให้ทำงานต่อจาก bind data เข้า autocomplete
      }
    });
    //Approver2Name
    const httpOptionsApprover2 = { //ประกาศตัวแปรเพื่อส่งค่าไปยัง HttpGet
      headers: new HttpHeaders({ //ใช้ส่งค่าในการกำหนดรูปแบบการส่งข้อมูลไปยัง HttpGet
        'Content-Type': 'application/json' //ประเภทรูปแบบ Json
      }),
      params: new HttpParams() //ตัวแปรที่ใช้ในการระบุฟิลเพื่อส่งไปยัง Controller
        //.set('sSearch', this.FilterGrid.sSearch)
        .set('sCompCode', this.AdvanceRequestForm.value.nCompanyCode)
        .set('nRole', "4")
    };
    await this.http.get<any>(this.System.SiteName + "api/AdvanceRequest/GetApprover2", httpOptionsApprover2).toPromise().then(res => {
      if (res) {
        this.DataApprover2 = res;
        this.ArrApprover2 = this.DataApprover2.map(m => ({
          nUserID: m.nUserID,
          sApprover: m.sName + " " + m.sSurName
        }));
        this.Flows(); //เรียกใช้ method Flows เพื่อให้ทำงานต่อจาก bind data เข้า autocomplete
      }
    });
  }

  Flows() { //method Flows ใช้ดึงข้อมูลมาเข้าเงื่อนไข flow approver
    //TM_Folws
    //if (isUndefined(this.sRequestID)) {
    if (this.sRequestID == "") {
      const httpOptionsTM_Folws = { //ประกาศตัวแปรเพื่อส่งค่าไปยัง HttpGet
        headers: new HttpHeaders({ //ใช้ส่งค่าในการกำหนดรูปแบบการส่งข้อมูลไปยัง HttpGet
          'Content-Type': 'application/json' //ประเภทรูปแบบ Json
        }),
        params: new HttpParams()
          .set('sCompCode', this.AdvanceRequestForm.value.nCompanyCode)
          .set('sReqType', "20")
      };
      this.http.get<any>(this.System.SiteName + "api/AdvanceRequest/GetTM_Flows", httpOptionsTM_Folws).subscribe(res => {
        if (res) {
          this.DataTM_Flows = res;
          this.ArrTM_Flows = this.DataTM_Flows.map(m => ({
            IsApprover_1: m.IsApprover_1,
            IsApprover_2: m.IsApprover_2,
            nApproveID1: m.nApproveID1,
            nApproveID2: m.nApproveID2,
            cActive: m.cActive
          }));
          this.IsApprover_1 = this.DataTM_Flows[0].IsApprover_1;
          this.IsApprover_2 = this.DataTM_Flows[0].IsApprover_2;
          this.nApproveID1 = this.DataTM_Flows[0].nApproveID1;
          this.nApproveID2 = this.DataTM_Flows[0].nApproveID2;
          this.cActive = this.DataTM_Flows[0].cActive;
          this.setApprover(); //เรียกใช้ method setApprover
        }
      });
    }
  }

  setApprover() { //method setApprover ใช้ set value ตามเงื่อนไขในตาราง TM_Folws
    if (this.cActive == "Y") {
      if (this.IsApprover_1) { //เงื่อนไขถ้าเท่ากับ 1
        if (this.ArrApprover1) {
          let lstData = this.ArrApprover1.filter(f => f.nUserID == this.nApproveID1) //ตัวแปร lstData เก็บค่าที่ filter ด้วย nUserID จาก ArrApprover
          this.AdvanceRequestForm.patchValue({ //set value sApprover1
            sApproverID1: lstData[0].nUserID + "",
            sApprover1: lstData[0].sApprover + ""
          });
        }
      } else {
        this.AdvanceRequestForm.controls.cbApprover1.setValue(true);
        this.AdvanceRequestForm.controls.sApprover1.setValue(null);
        this.AdvanceRequestForm.controls.sApprover1.disable();
      }
      if (this.IsApprover_2) {
        if (this.ArrApprover2) {
          let lstData = this.ArrApprover2.filter(f => f.nUserID == this.nApproveID2) //ตัวแปร lstData เก็บค่าที่ filter ด้วย nUserID จาก ArrApprover
          this.AdvanceRequestForm.patchValue({ //set value sApprover1
            sApproverID2: lstData[0].nUserID + "",
            sApprover2: lstData[0].sApprover + ""
          });
        }
      } else {
        this.AdvanceRequestForm.controls.sApprover2.setValue(null);
        this.AdvanceRequestForm.controls.sApprover2.enable();
      }
    } else if (this.cActive == "N") {
      this.AdvanceRequestForm.controls.cbApprover1.setValue(false);
      this.AdvanceRequestForm.controls.sApprover1.enable();
      this.AdvanceRequestForm.controls.sApprover1.setValue(null);
      this.AdvanceRequestForm.controls.sApprover2.enable();
      this.AdvanceRequestForm.controls.sApprover2.setValue(null);
    }
  }

  onOptionsSelected_ContactName(event: TypeaheadMatch): void { //bind value เข้า autocomplete ContactName
    let txtSearch = event.item['nUserID'] //เลือกจาก nUserID
    let lstData = this.ArrEmployee.filter(user => user.nUserID == txtSearch)[0] //ตัวแปร lstData เก็บค่าที่ filter ด้วย nUserID จาก ArrEmployee
    if (lstData != "") { //เงื่อนไขถ้า lstData ไม่ใช่ค่าว่าง
      this.AdvanceRequestForm.patchValue({ //set value
        sContactID: lstData.nUserID + "",
        sContactName: lstData.sContactName,
        sEmail: lstData.sEmail,
        sUnit: lstData.sUnit,
        sTel: lstData.sTel
      });
    } else { //ถ้า lstData เป็นค่าว่าง
      this.AdvanceRequestForm.patchValue({
        sContactID: "",
        sContactName: "",
        sEmail: "",
        sUnit: "",
        sTel: ""
      });
    }
  }

  onOptionsSelected_ContactName2(sName: any) : void {
    let lstData = this.DataEmployee.filter(user => user.sName + " " + user.sSurName == sName)[0]
    if (lstData != "") {
      this.AdvanceRequestForm.patchValue({
        sEmail: lstData.sEmail,
        sContactName: sName,
        txtTel: lstData.sTel,
        sUnit: lstData.sUnit,
        sContactID: lstData.nUserID + "",
      });

    }
  }


  onOptionsSelected_sCopyofReqNo(event: TypeaheadMatch): void { //bind value เข้า autocomplete sCopyofReqNo
    let txtSearch = event.item; //เลือกจาก text ที่เลือก
    let lstData = this.DatasRequestCode.filter(no => no.sRequestCode == txtSearch.sCopyofReqNo) //ตัวแปร lstData เก็บค่าที่ filter ด้วย sRequestCode จาก DatasRequestCode
    if (lstData != "") { //เงื่อนไขถ้า lstData ไม่ใช่ค่าว่าง
      this.AdvanceRequestForm.patchValue({ //set value
        sCopyReqID: lstData[0].sRequestID,
        sCopyofReqNo: lstData[0].sRequestCode,
        VENDOR_CODE: lstData[0].sVendorCode,
        sVendorName: lstData[0].sVendorName,
        sTAXID: !_IsNullOrEmpty(lstData[0].sTAXID) ? lstData[0].sTAXID : "-",
        sVendorAddress: !_IsNullOrEmpty(lstData[0].sVendorAddress) ? lstData[0].sVendorAddress : "-",
        nAmount: lstData[0].nGrandTotalAmt == null ? "" : this._ConvertToDecimal(lstData[0].nExcludeVAT + ""), //short if แปลงตัวเลขให้เป็น format comma
        sDescription: lstData[0].sInvoiceDesc,
        cbApprover1: lstData[0].cSkipApprove1 == "Y" ? true : false
      });

      if (this.AdvanceRequestForm.controls.cbApprover1.value) {
        this.AdvanceRequestForm.controls.cbApprover1.setValue(true);
        this.AdvanceRequestForm.controls.sApprover1.setValue(null);
        this.AdvanceRequestForm.controls.sApprover1.disable();
      } else {
        let sApprover1 = this.ArrApprover1.filter(f => f.nUserID == lstData[0].nApprove1);
        if (sApprover1) {
          this.AdvanceRequestForm.controls.sApprover1.setValue(sApprover1[0].sApprover);
          this.AdvanceRequestForm.controls.sApprover1.enable();
        }
      }

      let sApprover2 = this.ArrApprover2.filter(f => f.nUserID == lstData[0].nApprove2);
      if (sApprover2) {
        this.AdvanceRequestForm.controls.sApprover2.setValue(sApprover2[0].sApprover);
      }

    } else { //ถ้า lstData เป็นค่าว่าง
      this.AdvanceRequestForm.patchValue({
        sCopyofReqNo: "",
        VENDOR_CODE: "",
        sVendorName: "",
        sTAXID: "",
        sVendorAddress: "",
        nAmount: "",
        sDescription: "",
        cbApprover1: false,
        sApprover1: "",
        sApprover2: ""
      });
    }
  }

  onOptionsSelected_VendorCode(event: TypeaheadMatch): void { //bind value เข้า autocomplete VendorCode
    let taxID: any[]; //ตัวแปรเก็บค่า taxID จากเงื่อนไข
    let txtSearch = event.item; //เลือกจาก text ที่เลือก    if (event.item.VENDOR_CODE != undefined && event.item.VENDOR_CODE != "") {
    if (txtSearch.VENDOR_CODE != undefined && txtSearch.VENDOR_CODE != "") {
      let lstData = this.DataVENDOR_CODE.filter(code => code.VENDOR_CODE == txtSearch.VENDOR_CODE)[0] //ตัวแปร lstData เก็บค่าที่ filter ด้วย VENDOR_CODE จาก DataVENDOR_CODE
      if (lstData != "") { //เงื่อนไขถ้า lstData ไม่ใช่ค่าว่าง

        if (!_IsNullOrEmpty(lstData.TAX_NUMBER3)) { //เงื่อนไขถ้า TAX_NUMBER3 ไม่ใช่ค่าว่าง
          taxID = lstData.TAX_NUMBER3 //ให้ taxID เท่ากับ TAX_NUMBER3
        } else if (!_IsNullOrEmpty(lstData.TAX_NUMBER2)) { //เงื่อนไขถ้า TAX_NUMBER3 เป็นค่าว่างและ TAX_NUMBER2 ไม่ใช่ค่าว่าง
          taxID = lstData.TAX_NUMBER2 //ให้ taxID เท่ากับ TAX_NUMBER2
        } else if (!_IsNullOrEmpty(lstData.TAX_NUMBER1)) {
          taxID = lstData.TAX_NUMBER1 //ให้ taxID เท่ากับ TAX_NUMBER1
        }
        let sAddress = "";
        if (!_IsNullOrEmpty(lstData.sAddress)) {
          sAddress = lstData.sAddress.replace(/\s/g, "");
          if (_IsNullOrEmpty(sAddress)) {
            sAddress = "-";
          }
        } else {
          sAddress = lstData.sAddress;
        }
        this.AdvanceRequestForm.patchValue({ //set value
          VENDOR_CODE: lstData.VENDOR_CODE,
          sVendorName: lstData.sVendorName,
          sTAXID: !isUndefined(taxID) ? taxID : "-",
          sVendorAddress: sAddress
        });
      } else { //ถ้า lstData เป็นค่าว่าง
        this.AdvanceRequestForm.patchValue({
          VENDOR_CODE: "",
          sVendorName: "",
          sTAXID: "-",
          sVendorAddress: ""
        });
      }
    }
  }

  onSelectApprover(event: TypeaheadMatch, index: string): void {
    switch (index) {
      case 'sApprover1':
        this.AdvanceRequestForm.patchValue({
          sApproverID1: event.item['nUserID'] + ""
        });
        break
      case 'sApprover2':
        this.AdvanceRequestForm.patchValue({
          sApproverID2: event.item['nUserID'] + ""
        });
        break;
    }
  }

  typeaheadOnBlur_CopyofReqNo(event: boolean): void { //เช็คว่า autocomplete มี value ?
    let txtCopyReqNo = (this.AdvanceRequestForm.controls.sCopyofReqNo.value + "").trim();
    let lstData = this.DatasRequestCode.filter(no => no.sRequestCode == txtCopyReqNo) //ตัวแปร lstData เก็บค่าที่ filter ด้วย sRequestCode จาก DatasRequestCode
    if (lstData != "") { //เงื่อนไขถ้า lstData ไม่ใช่ค่าว่าง
      this.AdvanceRequestForm.patchValue({ //set value
        sCopyReqID: lstData[0].sRequestID,
        sCopyofReqNo: lstData[0].sRequestCode,
        VENDOR_CODE: lstData[0].sVendorCode,
        sVendorName: lstData[0].sVendorName,
        sTAXID: lstData[0].sTAXID,
        sVendorAddress: lstData[0].sVendorAddress,
        nAmount: lstData[0].nGrandTotalAmt == null ? "" : this._ConvertToDecimal(lstData[0].nExcludeVAT + ""), //short if แปลงตัวเลขให้เป็น format comma
        sDescription: lstData[0].sInvoiceDesc,
        cbApprover1: lstData[0].cSkipApprove1 == "Y" ? true : false
      });

      if (this.AdvanceRequestForm.controls.cbApprover1.value) {
        this.AdvanceRequestForm.controls.cbApprover1.setValue(true);
        this.AdvanceRequestForm.controls.sApprover1.setValue(null);
        this.AdvanceRequestForm.controls.sApprover1.disable();
      } else {
        let sApprover1 = this.ArrApprover1.filter(f => f.nUserID == lstData[0].nApprove1);
        if (sApprover1) {
          this.AdvanceRequestForm.controls.sApprover1.setValue(sApprover1[0].sApprover);
          this.AdvanceRequestForm.controls.sApprover1.enable();
        }
      }

      let sApprover2 = this.ArrApprover2.filter(f => f.nUserID == lstData[0].nApprove2);
      if (sApprover2) {
        this.AdvanceRequestForm.controls.sApprover2.setValue(sApprover2[0].sApprover);
      }

    } else { //ถ้า lstData เป็นค่าว่าง
      this.AdvanceRequestForm.patchValue({
        sCopyofReqNo: "",
        sTAXID: "-",
      });
    }
  }

  typeaheadOnBlur_VendorCode(event: boolean): void { //เช็คว่า autocomplete มี value ?
    //if (this.noResult == true) { //ไม่มีให้ blur
    //  this.AdvanceRequestForm.patchValue({
    //    VENDOR_CODE: ""
    //  });
    //}
    let taxID: any[]; //ตัวแปรเก็บค่า taxID จากเงื่อนไข
    let txtVendorCode = this.AdvanceRequestForm.controls.VENDOR_CODE.value;
    if (txtVendorCode != undefined && txtVendorCode != "") {
      let lstData = this.DataVENDOR_CODE.filter(code => code.VENDOR_CODE == txtVendorCode.trim())[0] //ตัวแปร lstData เก็บค่าที่ filter ด้วย VENDOR_CODE จาก DataVENDOR_CODE
      if (lstData != "" && !isUndefined(lstData) && lstData != null) { //เงื่อนไขถ้า lstData ไม่ใช่ค่าว่าง
        if (lstData.TAX_NUMBER3 != null) { //เงื่อนไขถ้า TAX_NUMBER3 ไม่ใช่ค่าว่าง
          taxID = lstData.TAX_NUMBER3 //ให้ taxID เท่ากับ TAX_NUMBER3
        } else if (lstData.TAX_NUMBER3 == null && lstData.TAX_NUMBER2 != null) { //เงื่อนไขถ้า TAX_NUMBER3 เป็นค่าว่างและ TAX_NUMBER2 ไม่ใช่ค่าว่าง
          taxID = lstData.TAX_NUMBER2 //ให้ taxID เท่ากับ TAX_NUMBER2
        } else {
          taxID = lstData.TAX_NUMBER1 //ให้ taxID เท่ากับ TAX_NUMBER1
        }
        this.AdvanceRequestForm.patchValue({ //set value
          VENDOR_CODE: lstData.VENDOR_CODE,
          sVendorName: lstData.sVendorName,
          sTAXID: taxID,
          sVendorAddress: lstData.sAddress
        });
      } else { //ถ้า lstData เป็นค่าว่าง
        this.AdvanceRequestForm.patchValue({
          VENDOR_CODE: ""
        });
      }
    }
  }

  typeaheadNoResults_Approver1(event: boolean): void { //เช็คว่า autocomplete มี value ?
    this.noResult = event; //true,false
  }

  typeaheadOnBlur_Approver1(event: boolean): void { //เช็คว่า autocomplete มี value ?
    if (this.noResult == true) { //ไม่มีให้ blur
      this.AdvanceRequestForm.patchValue({
        sApprover1: ""
      });
    }
  }

  typeaheadNoResults_Approver2(event: boolean): void { //เช็คว่า autocomplete มี value ?
    this.noResult = event; //true,false
  }

  typeaheadOnBlur_Approver2(event: boolean): void { //เช็คว่า autocomplete มี value ?
    if (this.noResult == true) { //ไม่มีให้ blur
      this.AdvanceRequestForm.patchValue({
        sApprover2: ""
      });
    }
  }

  numberOnly(event): boolean { //method กรอกข้อมูลเฉพาะตัวเลข
    const charCode = event.key;
    var regExp = new RegExp('[A-Za-z]', 'g');
    if (regExp.test(charCode)) {
      return false;
    } else {
      return true;
    }
  }

  handler() {
    var due = this.AdvanceRequestForm.value['dDue']
    var check_date = this.BusinessDay.setDueDatebyDate(this.Todate, due, this.Holidays)
    if (check_date < this.urgentDay) {
      this.message = 'You have ' + check_date + ' working days before due date. This is "Urgent" payment.'
      this.IsReqUrgent = true;
    } else {
      this.message = "";
      this.IsReqUrgent = false;
    }
    this.nReqUrgentDay = check_date;
  }

  chkSkip() {
    let chk = this.AdvanceRequestForm.value['cbApprover1']
    if (!chk) {
      this.cbApprover1 = false;
      this.nStatusID = 2;
      this.AdvanceRequestForm.get('sApprover1').enable();
      if (this.IsEdit == true) {
        this.AdvanceRequestForm.patchValue({
          sApprover1: this._NameApprover1 == null ? "" : this._NameApprover1
        });
      } else if (!this.IsApprover_1) {
        this.AdvanceRequestForm.patchValue({ //set value sApprover1
          sApproverID1: "",
          sApprover1: ""
        });
      }
      else {
        let lstData = this.ArrApprover1.filter(f => f.nUserID == this.nApproveID1) //ตัวแปร lstData เก็บค่าที่ filter ด้วย nUserID จาก ArrApprover
        this.AdvanceRequestForm.patchValue({ //set value sApprover1
          sApproverID1: lstData[0].nUserID + "",
          sApprover1: lstData[0].sApprover + ""
        });
      }
      //else {
      //  this.setApprover();
      //}
    } else {
      this.cbApprover1 = true;
      this.nStatusID = 4;
      this.AdvanceRequestForm.get('sApprover1').disable();
      this.AdvanceRequestForm.patchValue({
        sApprover1: ""
      });
      this.AdvanceRequestForm.get('sApprover1').reset()
    }
  }

  onClick(value: string) {
    let _this = this;
    let str = this.sRequestID;
    switch (value) {
      case "Draft":
        if (!this.AdvanceRequestForm.get('sContactName').valid) {
          const control = this.AdvanceRequestForm.get('sContactName');
          if (control instanceof FormControl) {
            control.markAsTouched({ onlySelf: true });
          }
        } else {
          this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.ConfirmSaveDraft, function () { _this.SaveDraft(str) }, undefined)
        }
        break;
      case "Submit":
        if ((this.AdvanceRequestForm.invalid) ||  (ArrFile.filter(f => f.IsDelete === false).length <= 0)) {
          this.validateAllFormFields(this.AdvanceRequestForm);
          this.cbApprover1 = this.AdvanceRequestForm.controls.cbApprover1.value;
          if (this.cbApprover1) {
            //Clear Validate
            this.AdvanceRequestForm.get("sApprover1").markAsUntouched({ onlySelf: true });
            this.AdvanceRequestForm.controls["sApprover1"].setErrors(null);
            this.AdvanceRequestForm.controls["sApprover1"].updateValueAndValidity();
          }

          if (ArrFile.filter(f => f.IsDelete === false).length <= 0) {
            const chkFile =  document.getElementById('dv_dvUploadFile');
            chkFile.style.border = '1px solid red';
          }


          let msg_err_VendorName = "";
          let msg_err_VendorAddress = "";
          let msg_err_TAXID = "";

          if (_IsNullOrEmpty(_this.AdvanceRequestForm.get('sVendorName').value)) {
            msg_err_VendorName += " Employee Name, ";
          }
          let AddressReplace = "";
          if (!_IsNullOrEmpty(this.AdvanceRequestForm.get('sVendorAddress').value)) {
            AddressReplace = this.AdvanceRequestForm.get('sVendorAddress').value.replace(/\s/g, "");
          }

          if (_IsNullOrEmpty(AddressReplace)) {
            msg_err_VendorAddress += " Employee Address, ";
          }
          if (_IsNullOrEmpty(_this.AdvanceRequestForm.get('sTAXID').value)) {
            msg_err_TAXID += " TAX ID ";
          }
          if (msg_err_VendorName || msg_err_VendorAddress || msg_err_TAXID) {
            this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, "Please Specify" + msg_err_VendorName + msg_err_VendorAddress + msg_err_TAXID, undefined);
          }

        } else {
          this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.Desc_Confirm_Submit, function () { _this.onSubmit(str) }, undefined)
        }
        break;
      case "Print":
        this.Export();
        break;
      case "Recall":
        this.SW.SwAlert.info(this.SW.BoxMsg.Title_info, "Recall.", function () { _this.Recall() })
        break;
      case "Back":
        this.router.navigate(["/home"]);
        break;
      case "Cancel":
        if (this.sComment === null || this.sComment === "" || this.sComment === undefined) {
          this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_Specify_Comment, undefined);
        }
        else {
          this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.Desc_Confirm_Delete, function () { _this.Delete() }, undefined)
        }
        break;
      default:
    }
    _this.clicked = false;

  }

  isFieldValid(field: string) {
    return !this.AdvanceRequestForm.get(field).valid && this.AdvanceRequestForm.get(field).touched;
  }

  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field),
      'has-feedback': this.isFieldValid(field)
    };
  }

  validateAllFormFields(formGroup: FormGroup) {         //{1}
    Object.keys(formGroup.controls).forEach(field => {  //{2}
      const control = formGroup.get(field);             //{3}
      if (control instanceof FormControl) {             //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        //{5}
        this.validateAllFormFields(control);            //{6}
      }
    });
  }

  onSubmit(str) {
    this.System.BlockUI();
    let _this = this;
    let _str = str;
    this.sRequestID = _str;

    if (!this.AdvanceRequestForm.value['cbApprover1']) {
      this.nStatusID = 2;
    } else {
      this.nStatusID = 4;
    }

    let sCopyReqID = null;
    if (this.AdvanceRequestForm.controls.sCopyofReqNo.value) {
      sCopyReqID = this.AdvanceRequestForm.value["sCopyReqID"];
    }

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set('nStatusID', this.nStatusID)
    };
    let formObj = {
      IsReqUrgent: this.IsReqUrgent,
      VENDOR_CODE: this.AdvanceRequestForm.value["VENDOR_CODE"],
      cbApprover1: this.AdvanceRequestForm.value["cbApprover1"],
      //dDue: this.AdvanceRequestForm.value["dDue"],
      dDue: _this.System._ParseDateToFormat(this.AdvanceRequestForm.value["dDue"], ''),
      nAmount: this.AdvanceRequestForm.value["nAmount"],
      nCompanyCode: this.AdvanceRequestForm.value["nCompanyCode"],
      nReqType: this.AdvanceRequestForm.value["nReqType"],
      sApprover1: this.AdvanceRequestForm.value["sApprover1"],
      sApprover2: this.AdvanceRequestForm.value["sApprover2"],
      sApproverID1: this.AdvanceRequestForm.value["sApproverID1"] + "",
      sApproverID2: this.AdvanceRequestForm.value["sApproverID2"] + "",
      sCompanyName: this.AdvanceRequestForm.value["sCompanyName"],
      sContactID: this.AdvanceRequestForm.value["sContactID"] + "",
      sContactName: this.AdvanceRequestForm.value["sContactName"],
      sCopyReqID: sCopyReqID,
      sCopyofReqNo: this.AdvanceRequestForm.value["sCopyofReqNo"],
      sCurrency: this.AdvanceRequestForm.value["sCurrency"],
      sDescription: this.AdvanceRequestForm.value["sDescription"],
      sEmail: this.AdvanceRequestForm.value["sEmail"],
      sTAXID: this.AdvanceRequestForm.value["sTAXID"],
      sTel: this.AdvanceRequestForm.value["sTel"],
      sUnit: this.AdvanceRequestForm.value["sUnit"],
      sBusinessArea: this.AdvanceRequestForm.value["sBusinessArea"],
      sVendorAddress: this.AdvanceRequestForm.controls.sVendorAddress.value,
      sVendorName: this.AdvanceRequestForm.value["sVendorName"],
      dStartDate: _this.System._ParseDateToFormat(this.Todate, ''),
      nReqUrgentDay: this.nReqUrgentDay,
      sComment: this.sComment,
      sCommentSSC: this.sCommentSSC
    }
    let TRequestItems = {
      sRequestID: "",
      VENDOR_CODE: this.AdvanceRequestForm.value["VENDOR_CODE"],
      sVendorName: this.AdvanceRequestForm.value["sVendorName"],
      sTAXID: this.AdvanceRequestForm.value["sTAXID"],
      sVendorAddress: this.AdvanceRequestForm.controls.sVendorAddress.value,
      sDescription: this.AdvanceRequestForm.value["sDescription"],
      sCurrency: this.AdvanceRequestForm.value["sCurrency"],
      nAmount: this.AdvanceRequestForm.value["nAmount"]
    }
    let sApproverID1 = "";
    let sApprover1 = "";
    if (this.AdvanceRequestForm.value["cbApprover1"] != true) {
      sApproverID1 = this.AdvanceRequestForm.value["sApproverID1"];
      sApprover1 = this.AdvanceRequestForm.value["sApprover1"];
    }
    let TRequestFlow = {
      cbApprover1: this.AdvanceRequestForm.value["cbApprover1"],
      sApproverID1: sApproverID1 + "",
      cApprove1: 'W',
      sApprover1: sApprover1,
      sApproverID2: _ParseString(this.AdvanceRequestForm.value["sApproverID2"]) + "",
      sApprover2: this.AdvanceRequestForm.value["sApprover2"],
      cApprove2: 'W'
    }
    let _ObjData = {
      sRequestID: _str,
      TRequest: formObj,
      TRequestItems: TRequestItems,
      TRequestFlow: TRequestFlow,
      fileupload: ArrFile
    }
    this.http.post<any>(this.System.SiteName + "api/AdvanceRequest/Save", _ObjData, httpOptions).subscribe(res => {
      this.System.UnBlockUI();
      if (res.Status == this.System.SysProcess.SessionExpired) {
        this.System.SessionExpire();
      }
      else if (res.Status == this.System.SysProcess.Success) {
        this.SW.SwAlert.Success(this.SW.BoxMsg.Title_Success, this.SW.BoxMsg.Desc_SaveComplete, function () {
          _this.router.navigate(['/home']);
        });
        Clearuploadfile();
      }
      else {
        this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, res.Msg, function () { Swal.close(); });
      }
    });
  }
  async Reject() {
    let _this = this;
    let sComment = _this.sComment;
    if (sComment === null || sComment === "") {
      _this.SW.SwAlert.Error(_this.SW.BoxMsg.Title_Error, _this.SW.BoxMsg.Desc_Specify_Comment, undefined)
    }
    else{
      let DataSave = {
        TRequest: {
          sRequestID: _this.sRequestID,
          sComment: sComment
        },
      }
      let Data = JSON.stringify(DataSave)
      let save = function () {
        _this.System.BlockUI();
        const headers = new HttpHeaders({
          'Content-Type': 'application/json'
        });
        _this.http.post(_this.System.SiteName + "api/ROService/Reject", Data, { headers, responseType: 'text' }).subscribe(s => {
          if (s == "Success") {
            ArrFile = [];
            _this.System.UnBlockUI();
            _this.SW.SwAlert.Success(_this.SW.BoxMsg.Title_Success, _this.SW.BoxMsg.Desc_SaveComplete, function () { _this.router.navigate(["ro-service"]) });
          } else {
            _this.System.UnBlockUI();
          }
        });
      }
      _this.SW.SwAlert.Confirm(_this.SW.BoxMsg.Title_Confirm, _this.SW.BoxMsg.Desc_Confirm_Submit, save, function () { });
    }
  }
  SaveDraft(str) {
    this.System.BlockUI();
    let _this = this;
    let _str = str;
    this.sRequestID = _str;
    let sCopyReqID = null;
    if (this.AdvanceRequestForm.controls.sCopyofReqNo.value) {
      sCopyReqID = this.AdvanceRequestForm.value["sCopyReqID"];
    }
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set('nStatusID', "1")
    };
    let formObj = {
      IsReqUrgent: this.IsReqUrgent,
      VENDOR_CODE: this.AdvanceRequestForm.value["VENDOR_CODE"],
      cbApprover1: this.AdvanceRequestForm.value["cbApprover1"],
      dDue: _this.System._ParseDateToFormat(this.AdvanceRequestForm.value["dDue"], ''),
      nAmount: this.AdvanceRequestForm.value["nAmount"],
      nCompanyCode: this.AdvanceRequestForm.value["nCompanyCode"],
      nReqType: this.AdvanceRequestForm.value["nReqType"],
      sApprover1: this.AdvanceRequestForm.value["sApprover1"],
      sApprover2: this.AdvanceRequestForm.value["sApprover2"],
      sApproverID1: this.AdvanceRequestForm.value["sApproverID1"] + "",
      sApproverID2: this.AdvanceRequestForm.value["sApproverID2"] + "",
      sCompanyName: this.AdvanceRequestForm.value["sCompanyName"],
      sContactID: this.AdvanceRequestForm.value["sContactID"] + "",
      sContactName: this.AdvanceRequestForm.value["sContactName"],
      sCopyReqID: sCopyReqID,
      sCopyofReqNo: this.AdvanceRequestForm.value["sCopyofReqNo"],
      sCurrency: this.AdvanceRequestForm.value["sCurrency"],
      sDescription: this.AdvanceRequestForm.value["sDescription"],
      sEmail: this.AdvanceRequestForm.value["sEmail"],
      sTAXID: this.AdvanceRequestForm.value["sTAXID"],
      sTel: this.AdvanceRequestForm.value["sTel"],
      sUnit: this.AdvanceRequestForm.value["sUnit"],
      sBusinessArea: this.AdvanceRequestForm.value["sBusinessArea"],
      sVendorAddress: this.AdvanceRequestForm.controls.sVendorAddress.value,
      sVendorName: this.AdvanceRequestForm.value["sVendorName"],
      dStartDate: _this.System._ParseDateToFormat(this.Todate, ''),
      nReqUrgentDay: this.nReqUrgentDay,
      sComment: this.sComment,
      sCommentSSC: this.sCommentSSC
    }
    let TRequestItems = {
      sRequestID: "",
      VENDOR_CODE: this.AdvanceRequestForm.value["VENDOR_CODE"],
      sVendorName: this.AdvanceRequestForm.value["sVendorName"],
      sTAXID: this.AdvanceRequestForm.value["sTAXID"],
      sVendorAddress: this.AdvanceRequestForm.controls.sVendorAddress.value,
      sDescription: this.AdvanceRequestForm.value["sDescription"],
      sCurrency: this.AdvanceRequestForm.value["sCurrency"],
      nAmount: this.AdvanceRequestForm.value["nAmount"]
    }
    let sApproverID1 = "";
    let sApprover1 = "";
    if (this.AdvanceRequestForm.value["cbApprover1"] != true) {
      sApproverID1 = this.AdvanceRequestForm.value["sApproverID1"];
      sApprover1 = this.AdvanceRequestForm.value["sApprover1"];
    }
    let TRequestFlow = {
      cbApprover1: this.AdvanceRequestForm.value["cbApprover1"],
      sApproverID1: sApproverID1 + "",
      cApprove1: 'W',
      sApprover1: sApprover1,
      sApproverID2: _ParseString(this.AdvanceRequestForm.value["sApproverID2"]) + "",
      sApprover2: this.AdvanceRequestForm.value["sApprover2"],
      cApprove2: 'W'
    }
    let _ObjData = {
      sRequestID: _str,
      TRequest: formObj,
      TRequestItems: TRequestItems,
      TRequestFlow: TRequestFlow,
      fileupload: ArrFile
    }
    this.http.post(this.System.SiteName + "api/AdvanceRequest/Save", _ObjData, httpOptions).subscribe(res => {
      this.System.UnBlockUI();
      if (res) {
        this.SW.SwAlert.Success(this.SW.BoxMsg.Title_Success, this.SW.BoxMsg.Desc_Success_Save, function () { _this.router.navigate(['/home']) })
        Clearuploadfile();
      }
      else {
        this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_Error, undefined)
      }
    });
  }

  async Edit(str) {
    this.System.BlockUI();
    let _str = str;
    this.sRequestID = _str;
    this.IsEdit = true;
    let file: any[];
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set('sRequestID', _str)
    };
    let sCopyReqID = "";
    this.ArrTransactionHistory = [];
    this.IsNoDataTrans = true;
    let res2 = await this.http.get<any>(this.System.SiteName + "api/_Paytovendor/GetTransactionHistory/" + encodeURIComponent(String(_str))).toPromise();
    if (res2) {
      this.ArrTransactionHistory = res2;
      if (this.ArrTransactionHistory.length > 0){
        this.IsNoDataTrans = false;
      }
    }
    let res = await this.http.get<any>(this.System.SiteName + "api/AdvanceRequest/GetDataAll", httpOptions).toPromise();
    if (res && res[0]) {
      this.sRequestCode = res[0].sRequestCode; //เอาไป set หลังจาก Submit แล้ว

      file = res[1];

      this.DataAll = res[0];
      if (this.DataAll != null) {
        if (this.DataAll.length != 0) {
          sCopyReqID = this.DataAll[0].sCopyReqID;
          this.getDisplayCopyofReqNo();
          //this.Todate = new Date(this.DataAll[0].dRequestDate);
          this.ArrDataAll = this.DataAll.map(m => ({
            sRequestID: m.sRequestID,
            sContactName: m.sContactName,
            sUnit: m.sUnitName,
            sDate: new Date(m.dRequestDate), //ตัวแปรเก็บวันที่ Request
            sEmail: m.sEmail,
            sTel: m.sTel,
            sBusinessArea: m.sBusinessArea,
            nReqType: m.nReqType + "",
            sCopyofReqNo: m.sCopyReqID,
            dDue: m.dDueDate,
            sDue: m.sDue,
            VENDOR_CODE: m.sVendorCode,
            sVendorName: m.sVendorName,
            sVendorAddress: m.sVendorAddress,
            sTAXID: m.sTAXID,
            nAmount: m.nGrandTotalAmt == 0 && m.nGrandTotalAmt !== null ? "" : this._ConvertToDecimal(m.nGrandTotalAmt + ""),
            sCurrency: m.sCurrency,
            nStatusID: m.nStatusID,
            sDescription: m.sInvoiceDesc,
            nApprove1: m.nApprove1,
            nApprove2: m.nApprove2,
            sApprover1: m.sNameApprover1,
            sApprover2: m.sNameApprover2,
            cbApprover1: m.cSkipApprove1 == "Y" ? true : false,
            IsReqUrgent: m.IsReqUrgent,
            sComment: m.sComment,
            sCommentSSC: m.sCommentSSC,
          }));

          //get file
          if (this.DataAll[0].sReferenceID) {
            file = this.DataAll.map(m => ({
              sReferenceID: m.sReferenceID,
              nFileOrder: m.nFileOrder,
              nMenuID: m.nMenuID,
              sFileName: m.sFileName,
              sSystemFileName: m.sSystemFileName,
              sPathFile: m.sPathFile,
              sFileSize: m.sFileSize
            }));
          }

          this._NameApprover1 = this.ArrDataAll[0].sApprover1 == null ? "" : this.ArrDataAll[0].sApprover1 + "";
          this.AdvanceRequestForm.patchValue({
            sContactName: this.ArrDataAll[0].sContactName,
            sUnit: this.ArrDataAll[0].sUnit,
            sDate: this.ArrDataAll[0].dRequestDate,
            sEmail: this.ArrDataAll[0].sEmail,
            sTel: this.ArrDataAll[0].sTel,
            sBusinessArea: this.ArrDataAll[0].sBusinessArea,
            nReqType: this.ArrDataAll[0].nReqType,
            //dDue: new Date(this.ArrDataAll[0].dDue),
            //dDue: this.ArrDataAll[0].sDue == null ? _FormatStringtoDate(new Date) : _FormatStringtoDate(new Date(this.ArrDataAll[0].sDue)),
            VENDOR_CODE: this.ArrDataAll[0].VENDOR_CODE,
            sVendorName: this.ArrDataAll[0].sVendorName,
            sVendorAddress: this.ArrDataAll[0].sVendorAddress,
            sTAXID: this.ArrDataAll[0].sTAXID,
            nAmount: this._ConvertToDecimal(this.ArrDataAll[0].nAmount),
            sCurrency: this.ArrDataAll[0].sCurrency,
            nStatusID: this.ArrDataAll[0].nStatusID,
            sDescription: this.ArrDataAll[0].sDescription,
            sApprover1: this.ArrDataAll[0].sApprover1,
            sApprover2: this.ArrDataAll[0].sApprover2,
            sApproverID1: this.ArrDataAll[0].nApprove1,
            sApproverID2: this.ArrDataAll[0].nApprove2,
            sComment: this.ArrDataAll[0].sComment,
            sCommentSSC: this.ArrDataAll[0].sCommentSSC,
            //cbApprover1: this.ArrDataAll[0].cbApprover1,
            //IsReqUrgent: this.ArrDataAll[0].IsReqUrgent
          });
          if (this.ArrDataAll[0].IsRoService) this.urgentDay = 8;
          if (this.DataAll[0].nStatusID == 1 || this.DataAll[0].nStatusID == 3) { //Status Draft , Reject
            this.fieldsetDisabled = false;
            this.nStatusID = 1;
            if (this.ArrDataAll[0].cbApprover1 == true) {
              this.AdvanceRequestForm.patchValue({
                cbApprover1: this.ArrDataAll[0].cbApprover1,
              });
              this.AdvanceRequestForm.controls.sApprover1.disable();
            }
          } else if (this.DataAll[0].nStatusID == 2) { //Status Submit
            this.fieldsetDisabled = true;
            this.nStatusID = 2;
          }

          //Set Due Date
          let DueDate = new Date(this.DataAll[0].sDue);
          this.Todate = this.BusinessDay.SetToday(this.Holidays);
          this.Mindate = this.BusinessDay.SetToday(this.Holidays);
          this.Mindate.setDate(this.Mindate.getDate() + 1);

          if (this.DataAll[0].nStatusID == 1 ||
            this.DataAll[0].nStatusID == 3 ||
            this.DataAll[0].nStatusID == 5 ||
            this.DataAll[0].nStatusID == 7 ||
            this.DataAll[0].nStatusID == 10) {
            let _Date = this.BusinessDay.setDueDatebyDate(this.Todate, DueDate, this.Holidays)
            if (_Date < this.urgentDay) {
              this.IsReqUrgent = _Date < 0 ? 0 : _Date
              this.IsReqUrgent = true
            } else {
              this.IsReqUrgent = false
            }
            this.AdvanceRequestForm.patchValue({
              dDue: DueDate
            });
          }

          if ((this.DataAll[0].nStatusID == 1 ||
            this.DataAll[0].nStatusID == 3 ||
            this.DataAll[0].nStatusID == 5 ||
            this.DataAll[0].nStatusID == 7 ||
            this.DataAll[0].nStatusID == 10) &&
            DueDate < this.Todate) {
            this.olddate = "Old Due Date " + this.DataAll[0].sDue;
            this.message = 'You have 1 working days before due date. This is "Urgent" payment.';
          }
          this.handler();
        }
      }

      //Check Status Skip Approver 1
      if (this.ArrDataAll[0].cbApprover1 == true) {
        this.nStatusID = 4;
        this.AdvanceRequestForm.controls.cbApprover1.setValue(true);
        this.AdvanceRequestForm.controls.sApprover1.disable();
      } else {
        this.nStatusID = 2;
      }

      //Check Permission
      let ObjData = {
        sRequestID: this.sRequestID,
        nMenuID: 7
      }
      this.ResultPermission = await this.System.CheckPermission(ObjData);
    }

    //Comment
    const httpOptionsComment = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set('sRequestID', this.sRequestID)
    };
    this.http.get<any>(this.System.SiteName + "api/AdvanceRequest/GetComment", httpOptionsComment).toPromise().then(res => {
      this.IsShowComment = true;
      if (res) {
        this.sComment = res[0].sComment;

        //setdata sComment เมื่อมีเลข Reject
        if (this.sComment) {
          this.AdvanceRequestForm.controls.sComment.setValue(this.sComment); //Set ค่า
          this.AdvanceRequestForm.patchValue({
            sComment: this.sComment,
          })
        }
      }
    });

    //UploadFile
    ArrFile.length = 0;
    if (file != null) {
      if (file.length > 0) {
        file.forEach(f => ArrFile.push({
          nID: f.nFileOrder,
          sPath: f.sPathFile,
          sSystemFileName: f.sSystemFileName,
          sFileName: f.sFileName,
          sSize: parseInt(f.sFileSize)
        }));
        SetData("dvUploadFile", ArrFile)
      }
    }

    this.System.UnBlockUI();
  }

  getDisplayCopyofReqNo() {
    let sCopyReqID = this.DataAll[0].sCopyReqID;
    const httpOptionsCopyReqID = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set('sCopyofReqNo', sCopyReqID)
    };
    this.http.get<any>(this.System.SiteName + "api/AdvanceRequest/GetDataCopyReqID", httpOptionsCopyReqID).subscribe(res => {
      if (res) {
        this.DataCopyReqID = res;
        if (this.DataCopyReqID.length != 0) {
          this.AdvanceRequestForm.patchValue({
            sCopyReqID: this.DataCopyReqID[0].sRequestID,
            sCopyofReqNo: this.DataCopyReqID[0].sRequestCode
          });
        }
      }
    });

  }

  Recall() {
    this.System.BlockUI();
    let _this = this;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set('sRequestID', this.sRequestID)
        .set('CommentDelete', this.sComment)
        .set('nStatusID', "0") //ส่งค่าไปเข้าเช็คเงื่อนไข
    };
    this.http.get<any>(this.System.SiteName + "api/AdvanceRequest/UpdateStatus", httpOptions).subscribe(res => {
      this.System.UnBlockUI();
      if (res == "Success") {
        this.SW.SwAlert.Success(this.SW.BoxMsg.Title_Success, "Data is already recalled.", function () {
          _this.router.navigate(['/home'])
        });
      } else {
        this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_Error, undefined);
      }
    });
  }

  Delete() {
    this.System.BlockUI();
    let _this = this;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set('sRequestID', this.sRequestID)
        .set('CommentDelete', this.sComment)
        .set('nStatusID', "1") //ส่งค่าไปเข้าเช็คเงื่อนไข
    };
    this.http.get<any>(this.System.SiteName + "api/AdvanceRequest/UpdateStatus", httpOptions).subscribe(res => {
      this.System.UnBlockUI();
      if (res == "Success") {
        this.SW.SwAlert.Success(this.SW.BoxMsg.Title_Success, 'Request is already cancel.', function () {
          _this.router.navigate(['/home'])
        });
      } else {
        this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_Error, undefined);
      }
    });
  }

  hideSubmit() {
    let Submit;
    if (this.sRequestID) {
      if (this.ResultPermission) {     //CheckPermission
        if (this.ArrDataAll.length > 0) {
          if (this.ArrDataAll[0].nStatusID == 1 ||
            this.ArrDataAll[0].nStatusID == 3 ||
            this.ArrDataAll[0].nStatusID == 5 ||
            this.ArrDataAll[0].nStatusID == 7 ||
            this.ArrDataAll[0].nStatusID == 10) {
            return Submit = true;
          } else if (this.ArrDataAll[0].nStatusID == 2) {
            return Submit = false;
          }
        }
      } else {
        return Submit = false;
      }
    } else {
      return Submit = true;
    }

  }

  hideCancel() {
    let Cancel;
    if (this.sRequestID) {
      if (this.ResultPermission) {     //CheckPermission
        if (this.ArrDataAll.length > 0) {
          if (this.ArrDataAll[0].nStatusID == 1 ||
            this.ArrDataAll[0].nStatusID == 3 ||
            this.ArrDataAll[0].nStatusID == 5 ||
            this.ArrDataAll[0].nStatusID == 7 ||
            this.ArrDataAll[0].nStatusID == 10) {
            return Cancel = true;
          } else if (this.ArrDataAll[0].nStatusID == 2) {
            return Cancel = false;
          }
        }
      } else {
        return Cancel = false;
      }
    } else {
      return Cancel = false;
    }
  }

  hideDraft() {
    let Draft;
    if (this.sRequestID) {
      if (this.ResultPermission) {
        if (this.ArrDataAll.length > 0) {
          if (this.ArrDataAll[0].nStatusID == 1 ||
            this.ArrDataAll[0].nStatusID == 3 ||
            this.ArrDataAll[0].nStatusID == 5 ||
            this.ArrDataAll[0].nStatusID == 7 ||
            this.ArrDataAll[0].nStatusID == 10) {
            return Draft = true;
          } else if (this.ArrDataAll[0].nStatusID == 2) {
            return Draft = false;
          }
        }
      } else {
        return Draft = false;
      }
    } else {
      return Draft = true;
    }
  }

  hidePrint() {
    let Print;
    if (this.sRequestID) {
      if (this.ResultPermission) {
        if (this.ArrDataAll.length > 0) {
          if (this.ArrDataAll[0].nStatusID == 1 ||
            this.ArrDataAll[0].nStatusID == 3 ||
            this.ArrDataAll[0].nStatusID == 5 ||
            this.ArrDataAll[0].nStatusID == 7 ||
            this.ArrDataAll[0].nStatusID == 10) {
            return Print = true;
          } else if (this.ArrDataAll[0].nStatusID == 2) {
            return Print = true;
          } else {
            return Print = false;
          }
        }
      } else {
        return Print = false;
      }
    } else {
      return Print = false;
    }
  }

  hideRecall() {
    let Recall;
    if (this.sRequestID) {
      if (this.ResultPermission) {
        if (this.ArrDataAll.length > 0) {
          if (this.ArrDataAll[0].nStatusID == 2) {
            return Recall = true;
          } else {
            return Recall = false;
          }
        }
      } else {
        return Recall = false;
      }
    } else {
      return Recall = false;
    }
  }

  _ConvertToDecimal(sVal) {
    let NoComma = (sVal + "").replace(/,/g, "");//ตัด Comma ออก
    NoComma = (NoComma + "").replace('null', "");//ตัด Comma ออก
    let Data = this._decimalPipe.transform(NoComma, "1.2-2");
    return Data;
  }

  onRightClick() { //method คลิกขวา ส่งค่า false ไปเพื่อไม่ให้สามารถคลิกขวาได้
    return false;
  }

  Export() {
    this.System.BlockUI();
    let ua = this.System.GetUserStorage();
    const link = document.createElement('a');
    link.target = '_blank'
    const httpOptions = {
      params: new HttpParams()
        .set("sReqID", this.sRequestID + "")
        .set("nContactID", ua.nUserID),
    };
    link.href = this.System.SiteName + "api/ExportPDF/export?" + httpOptions.params
    link.setAttribute('visibility', 'hidden');
    link.click(); this.System.UnBlockUI();
    this.System.UnBlockUI();
  }
}

function _FormatDate(date) {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2)
    month = '0' + month;
  if (day.length < 2)
    day = '0' + day;

  return [year, month, day].join('-');
}

function _FormatStringtoDate(sDate) {
  let arrDate = sDate.split('-');
  return new Date(arrDate[0], arrDate[1] - 1, arrDate[2]);
}

function _ParseString(str) {
  var Result = "";
  if (str && str != "null") {
    Result = str;
  }
  return Result;
}

function _IsNullOrEmpty(str) {
  var Result = true;
  if (str && str != "null") {
    Result = false;
  }
  return Result;
}
